import { useMutation, useQuery } from '@tanstack/react-query'
import { postNamedCommand, postNamedQuery } from '../../service'

export const useCreatePendingAuthorization = () => {
  return useMutation({
    mutationFn: async ({ purpose, payload }) => {
      const { data } = await postNamedCommand('users', 'create-pending-authorization', {
        purpose,
        data: payload
      })

      return data
    }
  })
}

export const useResolvePendingAuthorization = () => {
  return useMutation({
    mutationFn: async ({ authorizationId, purpose, payload }) => {
      const { data } = await postNamedCommand('users', 'resolve-pending-authorization', {
        authorizationId,
        purpose,
        data: payload
      })

      return data
    }
  })
}

export const useGetPendingAuthorizationStatus = (authorizationId, purpose) => {
  return useQuery({
    queryKey: ['users/get-pending-authorization-status', authorizationId, purpose],
    enabled: !!authorizationId,
    queryFn: async () => {
      const result = await postNamedQuery('users', 'get-pending-authorization-status', {
        authorizationId,
        purpose
      })

      return result.data
    }
  })
}

export const usePollPendingAuthorizationStatus = () => {
  return useMutation({
    mutationFn: async ({ authorizationId, purpose }) => {
      if (!authorizationId) {
        console.error('no authorization id')
        return null
      }
      const { data } = await postNamedQuery('users', 'get-pending-authorization-status', {
        authorizationId,
        purpose
      })

      return data
    }
  })
}
